import angular from 'angular';
import CheckComponent from './check.component';

const CheckModule = angular
    .module('control-room.commons.form.components.check', [])
    .component('crCheck', CheckComponent);

export default CheckModule;
